var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',{class:{'d-flex align-center': _vm.showIcon},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',[_vm._t("default")],2),(_vm.showIcon)?_c('v-btn',{class:{
        'mx-1 copy-icon': _vm.alwaysVisible ? false : true,
        'hover': hover
      },attrs:{"text":"","icon":"","x-small":"","width":"24","height":"24"},on:{"click":_vm.onCopyClick}},[_c('v-icon',[_vm._v("mdi-content-copy")])],1):_vm._e()],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }